(() => {
    class App {

        constructor() {
            this.intervals = {
                max:    10000,
                speed:  100,
                delay:  1,
            };

            /* Autoload */
            this.autoload('Model');
            this.autoload('Entities');
            this.autoload('Endpoint');
            this.autoload('Interface');
            this.autoload('Utilities');

            /* Actions are external javascript with event to load only when needed */
            this.Action = {};
            /* Globalize Requests */
            window._  = key => this.Interface.Translation.promise(key);
            window.__ = key => this.Interface.Translation.retrieve(key);
        }

        /* Constants */
        get ASSETS_PATH()   { return '/assets/js/' }
        get language()      { return this.Data.getConfiguration('translationLanguage') }

        /* Getters & Setters */
        get sessionId() {
            if (this._session === undefined) this._session = this.Data.getVariable('sessionId');
            return this._session;
        }
        set sessionId(id) {
            this._session = id;
        }

        autoload(namespace) {
            /*
            * AUTOLOAD
            * Autoload any namespace file with "App.*" with the Proxy API
            */
            if (typeof Proxy === 'undefined') {
                // Old Browsers and IE compatibility
                // Interfaces will be loaded in documents head in its own compressed file
                class StdClass {}
                this[namespace] = new StdClass();
            } else {
                let Self = this;
                this[namespace] = new Proxy(
                    {},
                    {
                        get(App, name) {
                            if (!(name in App)) {
                                // to load interfaces we need to force a sync loading
                                let async = $.ajaxSetup()['async'];
                                if (async) $.ajaxSetup({async: false});
                                Self.getScript('App/' + namespace + '/' + name, Self.ASSETS_PATH,'es6');
                                // If file has not been loaded correctly, stop looking for file
                                if (App[name] === undefined) {
                                    App[name] = true;
                                    Self.error('Autoload: ' + namespace + ' ' + name + ' not found');
                                }
                                // return to its original state
                                if (async) $.ajaxSetup({async: async});
                            }
                            return App[name];
                        }
                    }
                );
            }
            return this;
        }

        /* Services are the events to trigger as service worker (example: onFocus) */
        get Observer() {
            if (!this._observer) this._observer = new this.Entities.Observer(this);
            return this._observer;
        }

        /**
         * Execute a callback if the page is ready or any content is loaded per xhr.
         *
         * @param callback function The callback to execute.
         */
        load(callback) {
            $(callback);
            $(document).ajaxComplete(callback);
        }

        /*
        * Waits until App is ready
        *
        * intervals check that processes never run on the same time to avoid recursion
        *
        * */
        ready(callback, delay = 0) {
            setTimeout(function() {
                callback();
            }, delay === 0 ? this.intervals.delay++ : delay);
        }

        /**
         * Wait for var to be available and run a callback if given
         *
         * @param variable STRING to wait for
         * @param callback (optional)
         * @param comparison (undefined, null, empty, etc.) Run callback only if is different to this value
         */
        wait(variable, callback = () => {}, comparison = undefined) {
            return new Promise((resolve, reject) => {
                if (typeof variable !== 'string') this.error('Variable has to be in form of string');
                let data;

                let findData = function() {
                    let data, i = 0, exist = null, split = variable.split('.');
                    split.forEach(function(name) {
                        let source = (exist === null) ? window : exist;
                        if (source[name] !== undefined) {
                            exist   = source[name];
                            data    = (++i == split.length) ? exist : undefined ;
                        }
                    });
                    return data;
                };

                // return data directly if already available
                data = findData();
                if (data !== comparison) {
                    callback(data);
                    resolve(data);
                    return;
                }

                let intervalId = setInterval(() => {
                    data = findData();
                    if (data !== comparison) {
                        try {
                            callback(data);
                            resolve(data);
                            clearInterval(intervalId);
                        } finally {
                            // Use finally because Catch stops all JS scripts
                        }
                        reject();
                        return false;
                    }
                }, 100);
                setTimeout(() => {
                    clearInterval(intervalId);
                    if (data === comparison) {
                        reject();
                        this.error('TIMEOUT: Variable not found: ' + variable);
                    }
                }, this.intervals.max);
            });
        }

        await(parent, value) {
            return new Promise((resolve, reject) => {
                const interval = setInterval(() => {
                    if (parent[value] !== undefined) {
                        clearInterval(interval);
                        resolve(parent[value]);
                    }
                }, 100);

                // Optional timeout to avoid infinite loop
                setTimeout(() => {
                    clearInterval(interval);
                    reject(new Error('Timeout: value not set in time'));
                }, this.intervals.max);
            });
        }

        /* Get its own "getScript" to run AMD scripts independently in case we change our Library */
        getScript(file, path = this.ASSETS_PATH, format = 'js') {
            let fileName = [path + file, format].join('.');
            $.getScript([fileName, this.Setting('cache_bust')].join('?'));
        }

        /*
        * execute
        *
        * Execute script and bind it to the global scope
        * Scripts located in pub/assets/js/Action can be execute over the PHP Interface
        *
        * @param string action
        * @param object parameters
        */
        execute(action, parameters = {}) {
            return new Promise((resolve, reject) => {
                if (this.Action[action] === undefined) {
                    $.getScript(mmdata.route['interface-js-action'] + action, () => {
                        if (typeof this.Action[action] === 'function') {
                            resolve(this.Action[action](parameters));
                        } else {
                            reject();
                        }
                    });
                } else {
                    resolve(this.Action[action](parameters));
                }
            });
        }

        /*
        * call
        *
        * Call simple Global Method only if exists
        *
        * @param method Global Method to call
        */
        call(method) {
            if (window[method] !== undefined && typeof window[method] === 'function') {
                (() => window[method]())();
            }
        }

        /**
         * Analog to JS setInterval
         * It set an interval but also clear it after a while
         * @param callback
         * @param timeout
         * @returns {number}
         */
        setInterval(callback, timeout = this.intervals.speed) {
            const interval = setInterval(callback, timeout);
            setTimeout(() => clearInterval(interval), timeout * 100);
            return interval;
        }

        /**
         * Analog to throw new Error
         * @param message
         * @returns {Promise<void>}
         */
        error(message) {
            if (this.Variable('environment') === 'development') {
                console.error(message);
            }
        }
    }
    window.App = new App();
})();
